<template>
  <div class="custom-toolbar">
    <div :id="id">
      <select class="ql-align">
        <option selected></option>
        <option value="center"></option>
        <option value="right"></option>
      </select>
      <button class="ql-bold"></button>
      <el-dropdown
        v-if="type === 'shop'"
        size="small"
        trigger="click"
        @command="value => $emit('onInsert', value)"
        style="float: right;"
      >
        <el-button size="mini"
          class="var-dropdown-button">
          Változó beillesztése <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(variable, index) in variables"
            :key="index"
            :command="variable"
            :divided="variable.divided"
          >
            {{ variable.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
  import variables from '../../../variables';

  export default {
    props: ['id', 'type'],
    computed: {
      variables() {
        return variables.call(this);
      },
    },
  };
</script>

<style>
  .custom-toolbar .el-dropdown button {
    width: 100%;
    padding: 0 8px;
    border-radius: 3px;
    border: 1px solid #dcdfe6;
    transition: 0.3s;
  }

  .custom-toolbar .el-dropdown button:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
    transition: 0.3s;
  }
</style>
